import React, { useState } from "react";

// Prayer items from mission feedback. Long ones are cut short, with a
// "see more" / "see less" toggle to open or close the rest.
function PrayerText({ text, previewLength = 110, label = "Prayer items:" }) {
    const [open, setOpen] = useState(false);
    const prayer = (text || "").trim();
    const isLong = prayer.length > previewLength;
    const shown = isLong && !open ? `${prayer.slice(0, previewLength).trimEnd()}...` : prayer;

    return (
        <p className="cf-fb-prayer">
            {label && <><b>{label}</b>{" "}</>}
            {prayer ? shown : "None recorded."}
            {isLong && (
                <>
                    {" "}
                    <button
                        type="button"
                        className="cf-more-toggle"
                        onClick={() => setOpen(!open)}
                        aria-expanded={open}
                    >
                        {open ? "See less" : "See more"}
                    </button>
                </>
            )}
        </p>
    );
}

export default PrayerText;
